export const InvoiceDefaultValue = {
  id: '',
  invoiceQbId: '',
  invoiceAccountId: '',
  invoiceQbNumber: '',
  invoiceType: '',
  date: '',
  amountDue: 0,
  dueDate: '',
  paidDate: '',
  status: {
    days: 0,
    state: '',
  },
  timeLogsLink: '',
  taskLink: '',
  stripeLink: '',
  company: '',
  companyHsId: '',
  services: [],
  discountAmount: 0,
  serviceReference: '',
  serviceDescription: '',
  companyDisableAccessToZstream: false,
  fee: 0,
  feePercentage: 0,
  currency: '',
  qbRegion: '',
  isManual: false,
  isSystemCreated: false,
};
